import { LOCAL_CONTROL_UNIT_API, LOCAL_NAVIGATION_API } from '@/constants'

/**
 * Prepends `http://` when the URL has no scheme; URLs already starting with
 * `http://` or `https://` are returned unchanged (never downgrades HTTPS).
 *
 * Only meant for host[:port] style inputs — other schemes (`ftp://`) or
 * protocol-relative URLs (`//host`) would get a second scheme prepended.
 */
function withDefaultProtocol(url: string) {
  if (!url.startsWith('http://') && !url.startsWith('https://')) {
    return `http://${url}`
  }

  return url
}

function getNavigationApiUrl(): string {
  return withDefaultProtocol(LOCAL_NAVIGATION_API)
}

function getControlUnitApiUrl(): string {
  const override =
    import.meta.env.VITE_CONTROL_UNIT_API_URL ||
    (typeof window !== 'undefined' ? window.ENV?.CONTROL_UNIT_API_URL : undefined)

  return withDefaultProtocol(override || LOCAL_CONTROL_UNIT_API)
}

export { getControlUnitApiUrl, getNavigationApiUrl, withDefaultProtocol }
